import React, { useState } from "react";

const DECISION_STYLE = {
  APPROVAL_REQUIRED: "text-yellow-400 bg-yellow-500/10 border-yellow-500/20",
  PRIORITY_REVIEW:   "text-red-400 bg-red-500/10 border-red-500/20",
  ESCALATION:        "text-purple-400 bg-purple-500/10 border-purple-500/20",
};

const PRIORITY_COLOR = { P1: "#f87171", P2: "#fb923c", P3: "#fbbf24", P4: "rgba(255,255,255,0.3)" };

export default function ApprovalsQueue({ loading, items, onApprove, onReject }) {
  const [comments, setComments] = useState({});
  const setComment = (id, val) => setComments(c => ({ ...c, [id]: val }));

  if (loading) {
    return (
      <div className="space-y-2">
        {Array.from({ length: 3 }).map((_, i) => (
          <div key={i} className="h-20 rounded-xl border border-[#00ff90]/20 bg-[#0d0d0d] animate-pulse" />
        ))}
      </div>
    );
  }

  if (!items?.length) {
    return <p className="text-white/30 text-sm py-4 text-center italic">No items awaiting your action.</p>;
  }

  return (
    <div className="space-y-3">
      {items.map(x => {
        const decided = x.decided;
        const decisionStyle = DECISION_STYLE[x.decision] || "text-white/40 bg-white/5 border-white/10";
        const priorityColor = PRIORITY_COLOR[x.priority] || "rgba(255,255,255,0.3)";

        return (
          <div key={x.id} className="rounded-xl border border-[#00ff90]/15 bg-[#0d0d0d] p-4">
            <div className="flex items-start justify-between gap-4 flex-wrap">
              <div className="min-w-0">
                <div className="flex items-center gap-2 flex-wrap mb-1">
                  <span className="text-xs font-mono text-white/30">{x.id}</span>
                  <span className="text-sm font-medium text-white">{x.title}</span>
                </div>
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="text-xs text-white/40">By {x.requester}</span>
                  <span className="text-xs font-medium" style={{ color: priorityColor }}>{x.priority}</span>
                  <span className={`text-xs px-2 py-0.5 rounded-full border ${decisionStyle}`}>
                    {(x.decision || "").replace("_", " ")}
                  </span>
                </div>
                {x.reason && <p className="text-xs text-white/30 mt-1">{x.reason}</p>}
              </div>

              {decided ? (
                <span className={`text-xs px-2.5 py-1 rounded-full border shrink-0 ${
                  decided === "APPROVED" ? "border-[#00ff90]/20 text-[#00ff90]/50 bg-[#00ff90]/5"
                  : "border-red-500/20 text-red-400/50 bg-red-500/5"
                }`}>{decided}</span>
              ) : (
                <div className="flex items-center gap-2 shrink-0 flex-wrap">
                  <input
                    placeholder="Comment (optional)"
                    value={comments[x.id] || ""}
                    onChange={e => setComment(x.id, e.target.value)}
                    className="bg-black border border-white/10 rounded-lg px-3 py-1.5 text-xs text-white outline-none focus:border-[#00ff90]/30 transition-colors w-40"
                  />
                  <button onClick={() => onApprove?.(x.id, comments[x.id] || "")}
                    className="text-xs px-3 py-1.5 rounded-lg border border-[#00ff90]/25 bg-[#00ff90]/8 text-[#00ff90]/70 hover:bg-[#00ff90]/15 hover:text-[#00ff90] transition-colors">
                    Approve
                  </button>
                  <button onClick={() => onReject?.(x.id, comments[x.id] || "")}
                    className="text-xs px-3 py-1.5 rounded-lg border border-red-500/25 bg-red-500/8 text-red-400/70 hover:bg-red-500/15 hover:text-red-400 transition-colors">
                    Reject
                  </button>
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}